import {
  call, put, delay, select,
} from 'redux-saga/effects';
import moment from 'moment/moment';
import processError from '../../../utils/processError';
import {
  addProgressLog, setProgressList, showProgressBar, stoppedProgressBar,
} from '../../System/actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { USER_COMMAND_NAMES } from '../../../configs';
import { localeFormatter } from '../../../utils/formatters';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';
import { BAD_REQUEST } from '../../../configs/serverStatusCodes';
import {
  annulmentSZLT,
  archiveSZLT,
  deleteSZLT,
  inactiveSZLT, loadSZLTById, restoreSZLT,
  resumedSZLT, szltRegistryBatchCommandFailed, szltRegistryBatchCommandSuccessful,
  unarchiveSZLT,
} from '../actions';

const getStop = state => {
  const {
    [SYSTEM_MODULE]: {
      stopProgressBar = false,
    },
  } = state;
  return stopProgressBar;
};

const BATCH_COMMAND_ACTIONS = {
  [USER_COMMAND_NAMES.ANNULMENT]: annulmentSZLT,
  [USER_COMMAND_NAMES.INACTIVE]: inactiveSZLT,
  [USER_COMMAND_NAMES.RESUMED]: resumedSZLT,
  [USER_COMMAND_NAMES.DELETED]: deleteSZLT,
  [USER_COMMAND_NAMES.ARCHIVED]: archiveSZLT,
  [USER_COMMAND_NAMES.IN_ARCHIVED]: unarchiveSZLT,
  [USER_COMMAND_NAMES.RESTORE]: restoreSZLT,
};

export default function* szltRegistryBatchCommand(action) {
  try {
    if (!action.payload.items || !Array.isArray(action.payload.items) || !action.payload.key) {
      throw new Error(BAD_REQUEST);
    }

    let result = 0;
    let stopImport = false;
    const {
      items, key, values,
    } = action.payload;

    yield put(showProgressBar({
      title: `Пакетное [${localeFormatter('user.command', key)}]`,
      text: 'group.user.command',
    }));

    for (const item of items) {
      stopImport = yield select(getStop);

      const promiseRegistry = yield put(loadSZLTById(item));
      const { number } = yield promiseRegistry;
      const time = moment().format('HH:mm:ss');
      if (!number) {
        yield put(addProgressLog({ log: `<span style="color: red">${time} - Рестровая запись не имеет номера</div>`, withOutTime: true }));
        continue;
      }

      try {
        const promiseCommand = yield put(BATCH_COMMAND_ACTIONS[key](values ? { id: item, values } : item));
        yield promiseCommand;
        yield put(addProgressLog({ log: `Рестровая запись № ${number} - [${localeFormatter('user.command', key)}] успех` }));
      } catch (error) {
        yield put(addProgressLog({ log: `<span style="color: red">${time} - Рестровая запись № ${number} - [${localeFormatter('user.command', key)}] ${error?.message}</div>`, withOutTime: true }));
      }
      result++;
      yield put((setProgressList({
        progressCountSuccess: result,
        progressPercent: (result / items.length) * 100,
        progressCount: items.length,
      })));

      if (stopImport) {
        yield put(stoppedProgressBar());
        break;
      }
      yield delay(1000);
    }

    yield put(addProgressLog({ log: `Пакетное [${localeFormatter('user.command', key)}] завершено` }));
    yield put(stoppedProgressBar());
    yield put(setProgressList({
      progressCountSuccess: result,
      progressPercent: 100,
      progressCount: items.length,
    }));
    yield put(szltRegistryBatchCommandSuccessful());
    yield call(resolveActionPromise(action));
  } catch (e) {
    yield put(szltRegistryBatchCommandFailed());
    yield handleImportFailure(e);
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}

function* handleImportFailure(error) {
  const time = moment().format('HH:mm:ss');
  yield put(addProgressLog({ log: `<span style="color: red">${time} - Ошибка импорта: ${error || 'Ошибка без сообщения'}</span>`, withOutTime: true }));
  yield put(stoppedProgressBar());
  yield put(setProgressList({ progressPercent: 100 }));
}
